<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 1/10/2020
  -->

<template>
	<router-view v-bind="$attrs"></router-view>
</template>

<script>
    export default {
        name: "EmptyRouterView",
		inheritAttrs: false,
    }
</script>
